"use client";

import React, { useState } from "react";
import { Button, Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useClientTranslations } from "@/lib/translate";
import WriteReviewForm from "./WriteReviewForm";

const WriteReview = ({
  companyId,
}: {
  companyId: string;
  isLoggedIn?: boolean;
}) => {
  const { t } = useClientTranslations("review");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Button
        className="border border-primary text-primary rounded-md px-4 py-2 hover:bg-primary hover:text-white transition-colors duration-300"
        onClick={() => setIsOpen(true)}
      >
        {t("write_a_review")}
      </Button>
      <Dialog
        open={isOpen}
        as="div"
        className="relative z-10 focus:outline-none"
        onClose={() => setIsOpen(false)}
      >
        <DialogBackdrop className="fixed inset-0 bg-black/30" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className="min-w-full sm:min-w-xl flex flex-col items-center justify-center"
            >
              <WriteReviewForm
                companyId={companyId}
                onClose={() => setIsOpen(false)}
              />
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default WriteReview;
WriteReview.displayName = "WriteReview";
